<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <div class="filter__name">任务名：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">任务ID：</div>
        <el-input v-model="filters.etid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">广告：</div>
        <adSelect v-model="filters.adid" :lists.sync="adLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">口令墙：</div>
        <watchSelect v-model="filters.awid" :lists.sync="watchwordLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">首页显示：</div>
        <el-select class="filter__input" size="mini" v-model="filters.home">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in homeList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="ml-auto">
        <router-link class="blue-small-btn" :to="{path: '/taskEdit', query: {etid: 0}}">新建</router-link>
      </div>
    </div>
    <div class="filter mt-10 mb-20">
      <div class="filter__item">
        <div class="filter__name">负责人：</div>
        <operSelect v-model="filters.opid" :lists.sync="operLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">下家：</div>
        <adChnSelect v-model="filters.acid" :lists.sync="adChnLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">收款：</div>
        <taskIeffectSelect v-model="filters.ieffect" :need-filter="true" />
      </div>
      <button class="blue-small-btn mr-10" @click="getList">搜索</button>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="600" :summary-method="getSummaries" show-summary>
      <el-table-column prop="etid" label="任务ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="title" label="任务名" width="" align="center">
      </el-table-column>
      <el-table-column prop="oper_nickname" label="负责人" width="" align="center">
      </el-table-column>
      <el-table-column prop="acid" label="下家" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.chn_name}}({{scope.row.acid}})</div>
        </template>
      </el-table-column>
      <el-table-column label="复制" width="" align="center">
       <template slot-scope="scope">
          <router-link class="fs-18 ml-10" :to="{path: '/taskEdit', query: {copy_etid: scope.row.etid, etid: 0}}">
            <i class="el-icon-copy-document"></i>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="" label="详情" width="" align="center">
        <template slot-scope="scope">
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <div>要求：{{scope.row.demand}}</div><br />
              <div>口令：{{scope.row.keyword}}</div><br />
              <div> 优惠券：{{scope.row.coupon_url}}</div><br />
              <div class="flex"> 地址：
                <div v-html="scope.row.address.replace(/\|/g, '<br />')"></div>
              </div>
            </div>
            <el-button size="mini">显示</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="upload_url" label="交单链接" width="" align="center">
        <template slot-scope="scope">
         <el-button type="primary" icon="el-icon-document-copy" size="mini" class="copy-btn" @click="copyLink"  :data-clipboard-text="scope.row.upload_url"></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="adid" label="广告" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.adid !== 0"  @dblclick="setFiltersValue('adid', scope.row.adid)">{{scope.row.ad_title}}({{scope.row.adid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="awid" label="口令" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.awid !== 0" @dblclick="setFiltersValue('awid', scope.row.awid)">{{scope.row.watchword_title}}({{scope.row.awid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" align="center">
        <template slot-scope="scope">
          <div class="flex jcc aic">
            <div v-if="scope.row.status == 2" class="normal-btn">完结</div>
            <div v-if="scope.row.status == 1" class="blue-small-btn" @click="taskEdit(scope.$index, 'status')">运行</div>
            <div v-if="scope.row.status == 0" class="red-small-btn" @click="taskEdit(scope.$index, 'status')">下架</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="home" label="首页显示" width="100" align="center">
        <template slot-scope="scope">
          <div class="flex jcc aic">
            <el-button v-if="scope.row.home == 1" type="primary" plain size="mini" @click="taskEdit(scope.$index, 'home')">显示</el-button>
            <el-button v-if="scope.row.home == 0" type="info" plain size="mini" @click="taskEdit(scope.$index, 'home')">隐藏</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="底价折扣" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.min_discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="用户折扣" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="agency_fees" label="拍收费" width="" align="center">
      </el-table-column>
      <el-table-column prop="bonus" label="发票奖励" width="" align="center">
      </el-table-column>
      <el-table-column prop="quota" label="总单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="订单数/有效数" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.order_num}}/{{scope.row.ocount}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="today_ocount" label="当日出单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="current" label="剩余单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="总报单/丢单金额" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.payment}}/{{scope.row.invalid_payment}}</div>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="upload_url" label="下载对账数据" width="" align="center">
        <template slot-scope="scope">
         <el-button type="primary" icon="el-icon-download" size="mini" class="copy-btn" @click="download(scope.row.etid)"  :data-clipboard-text="scope.row.upload_url"></el-button>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="amount" label="订单金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="income" label="应收单价" width="" align="center">
      </el-table-column>
      <el-table-column prop="profit_ratio" label="毛利率" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.profit_ratio}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="all_income" label="应收款" width="" align="center">
      </el-table-column>
      <el-table-column prop="chn_amount" label="已收" width="" align="center">
      </el-table-column>
      <el-table-column prop="unpaid" label="未收" width="" align="center">
       <template slot-scope="scope">
          <div v-if="scope.row.ieffect == 0" class="fc-red pointer">
            {{scope.row.unpaid}}
          </div>
          <div v-else> 0 </div>
        </template>
      </el-table-column>
      <el-table-column label="是否收款" width="100" align="center">
       <template slot-scope="scope">
          <div class="flex jcc aic">
            <div v-if="scope.row.ieffect == 1" class="white-small-btn" @click="taskEdit(scope.$index, 'ieffect')">已收</div>
            <div v-if="scope.row.ieffect == 0" class="red-small-btn" @click="taskEdit(scope.$index, 'ieffect')">未收</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <router-link class="fs-18 ml-10" :to="{path: '/taskEdit', query: {etid: scope.row.etid}}">
              <i class="el-icon-edit"></i>
            </router-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import Clipboard from 'clipboard'
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {taskLists, taskEdit, downloadAdOrderLists} from '../../../api/api'
import adSelect from '../../../components/data-select/adSelect.vue'
import operSelect from '../../../components/data-select/operSelect.vue'
import watchSelect from '../../../components/data-select/watchSelect.vue'
import adChnSelect from '../../../components/data-select/adChnSelect.vue'
import taskIeffectSelect from '../../../components/data-select/taskIeffectSelect'
export default {
  name: 'taskList',
  mixins: [mixinList],
  components: {
    adSelect,
    operSelect,
    watchSelect,
    adChnSelect,
    taskIeffectSelect
  },
  data () {
    return {
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '运行',
          value: 1
        },
        {
          name: '下架',
          value: 0
        },
        {
          name: '完结',
          value: 2
        }
      ],
      homeList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '显示',
          value: 1
        },
        {
          name: '隐藏',
          value: 0
        }
      ],
      lists: [],
      listLoading: false,
      adLists: [],
      operLists: [],
      watchwordLists: [],
      adChnLists: [],
      filters: {
        p: 1,
        l: 20,
        total: 0,
        etid: '',
        title: '',
        opid: '',
        acid: '',
        adid: '',
        awid: '',
        ieffect: '',
        status: '',
        home: ''
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['total', 'order_amount', 'remain', 'amount', 'income', 'all_income', 'chn_amount', 'unpaid'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    taskEdit (index, key) {
      let etid = this.lists[index].etid

      let params = {
        etid: etid
      }

      if (key === 'status') {
        params['status'] = this.lists[index].status === 1 ? 0 : 1
      }

      if (key === 'home') {
        params['home'] = this.lists[index].home === 1 ? 0 : 1
      }

      if (key === 'ieffect') {
        params['ieffect'] = this.lists[index].ieffect === 1 ? 0 : 1
      }

      taskEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: '服务器出错了',
            type: 'error'
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.etid !== '') {
        params.etid = filters.etid
      }

      if (filters.title !== '') {
        params.title = filters.title
      }

      if (filters.opid !== '') {
        params.opid = filters.opid
      }

      if (filters.acid !== '') {
        params.acid = filters.acid
      }

      if (filters.adid !== '') {
        params.adid = filters.adid
      }

      if (filters.awid !== '') {
        params.awid = filters.awid
      }

      if (filters.ieffect !== '') {
        params.ieffect = filters.ieffect
      }

      if (filters.status !== '') {
        params.status = filters.status
      }

      if (filters.home !== '') {
        params.home = filters.home
      }

      this.listLoading = true
      taskLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.notifyError('服务器出错了')
      })
    },
    download (etid) {
      let link = downloadAdOrderLists + '?choose=' + 4
      link = link + '&etid=' + etid
      window.open(link, 'a')
    },
    copyLink () {
      let clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', e => {
        this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success'
        })

        // 释放内存
        clipboard.destroy()
      })

      clipboard.on('error', e => {
        this.$notify({
          title: '失败',
          message: '复制失败',
          type: 'error'
        })

        // 释放内存
        clipboard.destroy()
      })
    },
    filterParamsChange () {
      this.filters.p = 1
      this.getList()
    }
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.etid': 'filterParamsChange',
    'filters.opid': 'filterParamsChange',
    'filters.acid': 'filterParamsChange',
    'filters.adid': 'filterParamsChange',
    'filters.awid': 'filterParamsChange',
    'filters.ieffect': 'filterParamsChange',
    'filters.title': 'filterParamsChange',
    'filters.status': 'filterParamsChange',
    'filters.home': 'filterParamsChange'
  },
  mounted () {
    this.getList()
    util.setCookie('createAddetail', '')
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/module/earn/taskList.vue